<template>
  <transition name="fade">
    <div class="project" :style="{transform:is_ie}" v-drag>
      <div role="document">
        <div class="modal-content" >
          <div class="modal-header">         
            <span class="modal-title">选择地区</span>
            <!-- <span class="modal-title">{{value}}</span> -->
            <span aria-hidden="true" class="modal-span" @click="close">&times;</span>  
          </div>
          <div class="modal-body" @scroll="table_cont">
            <!-- Table -->
            <table class="table table-hover text-nowrap" >
                <thead class="th" :style="{transform:'translateY('+tans_late+'px)'}">
                  <tr>
                      <template v-for="(item,index) in head_data">
                    <th :key="index" v-if="item.Name=='fld_name'||item.Name=='fld_short_name'">{{item.Comment}}</th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list,index) in list_data" :key="index" @click="col_radio(list.fld_record_id)"> 
                      <template v-for="(child_list,child_index) in head_data">
                    <td :key="child_index" v-if="child_list.Name=='fld_name'||child_list.Name=='fld_short_name'">{{list[child_list.Name]}}</td>
                    </template>
                    <td><input type="radio" v-model="list_radio" :value="list.fld_record_id"></td> 
                  </tr>
                </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="cancel_selection">{{cancel}}</button>
            <button type="button" class="btn btn-default-determine" @click="determine">{{confirm}}</button>
          </div>
          <!-- 加载状态 -->
          <div class="loading" v-if="anate"><i class="fa fa-spin fa-spinner"></i></div>
        </div>
      </div>
    </div>
     <!-- 提示组件 -->
	<tips v-if="sel_tips" :current_state="current_state" :language_pack="language_pack"></tips>
  </transition>
</template>
<script>
  import { mapState } from 'vuex';
  import api from "../api/index.js";
  import tips from "./tips.vue"
  export default {
    name: 'Project',
    components: {
      tips
    },
    computed:{
    //   head_title(){
    //     return '--'+this.$attrs.language_pack[this.sel_language].select_distribution_package+'--'
    //   },
      confirm(){
        return this.$attrs.language_pack[this.sel_language].confirm
      },
      cancel(){
        return this.$attrs.language_pack[this.sel_language].cancel
      },
      ...mapState({
        sel_language:'sel_language'
      })
    },
    data(){
      return {
        //错误提是信息
        current_state:'',
        //是否显示提是组件
        sel_tips:false,
        //距离头部的位置
        tans_late:'',
        //加载状态
        anate:true,
        //复选框的数组
        check_data:[],
        //获取的弹框数据
        list_data:[],
        //单选按钮
        list_radio:'',
        //头部数据
        show_data:null,
        //计数
        // count:0,
        head_data:[],
        rows:null,
        //标题
        value:'',
        //是否是ie
        is_ie:false
      }
    },
    mounted(){
    //   console.log(this.rule_data)
    //获取数据
    // if(this.rule_data!=undefined){
    //   console.log(this.key_s.Name)
      this.get_data(this.key_s.Name);
    // }
      
      
      //判断是不是ie
      this.t_ie()
    },
    props:[
      //有弹框的头部字段（根据此字段判断是否有弹框）
      'ppr_action',
      //有弹框的数据头部字段
      'ppr_action_param',
      //弹框中的函数
      'box_fun',
      //输入框中的值
      'rule_data',
      'key_s'
    ],
    methods:{
      
      t_ie(){
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          // this.is_ie='translate(-50%, -50%)'
        }
      },
      //捕获异步错误
	  async_error(promise){
	  	return promise.then(res => res).catch(error => this.error_message(error));
	  },
      //错误提示
	  error_message(message){
				this.sel_tips=true;
				this.current_state=message;
				window.setTimeout(()=>{
					this.sel_tips=false;
				},2000)
				this.anate=false;
	  },
      //有值的时候把对应的数据项选中
      selected_data(){
        if(this.rule_data!=undefined){
              this.list_data.forEach((item,index)=>{
                  if(this.rule_data==item.fld_short_name){
                    this.list_radio=item.fld_record_id
                  };            
              })
            }
      },
      //获取数据
      async get_data(key){
        // console.log(key)
         if(key=='fld_region'){
              // alert(0)
              // this.tb_key='fld_min_version';
                let res= await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_region',window.sessionStorage.getItem('userInfo')))
                this.head_data=res.data.FIELDS;
                let para={};
                para.userInfo=window.sessionStorage.getItem('userInfo');
                let res1= await this.async_error(api.getBoxData(res.data,para));
                // console.log(res1.data)
                res1.data.forEach((item,index)=>{
                //   if(item.fld_type==0){
                    this.list_data.push(item)
                //   }
                })
                this.selected_data()
                // this.list_data=res1.data;
                this.data_title='fld-min-version';
                this.anate=false;
            }
            if(key=='fld_large_area'){
              // this.tb_key='fld_min_version';
              // alert(0)
                let res= await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_large_area',window.sessionStorage.getItem('userInfo')))
                this.head_data=res.data.FIELDS;
                let para={};
                para.userInfo=window.sessionStorage.getItem('userInfo');
                let res1= await this.async_error(api.getBoxData(res.data,para));
                 res1.data.forEach((item,index)=>{
                //   if(item.fld_type==0){
                    this.list_data.push(item)
                //   }
                })
                this.selected_data()
                // this.list_data=res1.data;
                this.data_title='fld-max-version';
                this.anate=false;
            }
            // if(key=='fld_cndmin_version'||key=='fld_cndmax_version'){
            //   // this.tb_key='fld_min_version';
            //     let res= await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_versions',window.sessionStorage.getItem('userInfo')))
            //     this.head_data=res.data.FIELDS;
            //     let para={};
            //     para.userInfo=window.sessionStorage.getItem('userInfo');
            //     let res1= await this.async_error(api.getBoxData(res.data,para));
            //      res1.data.forEach((item,index)=>{
            //       if(item.fld_type==1){
            //         this.list_data.push(item)
            //       }
            //     })
            //     // this.list_data=res1.data;
            //     this.selected_data()
            //     this.data_title='fld-max-version';
            //     this.anate=false;
            // }
            // if(key=='fld_cdnmin_version'||key=='fld_cdnmax_version'){
            //   // this.tb_key='fld_min_version';
            //     let res= await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_versions',window.sessionStorage.getItem('userInfo')))
            //     this.head_data=res.data.FIELDS;
            //     let para={};
            //     para.userInfo=window.sessionStorage.getItem('userInfo');
            //     let res1= await this.async_error(api.getBoxData(res.data,para));
            //      res1.data.forEach((item,index)=>{
            //       if(item.fld_type==1){
            //         this.list_data.push(item)
            //       }
            //     })
            //     // this.list_data=res1.data;
            //     this.selected_data()
            //     this.data_title='fld-max-version';
            //     this.anate=false;
            // }
      },
      //固定表头
      table_cont(e){
				this.tans_late=e.target.scrollTop;
		  },
      //点击tr元素选中radio标签
      col_radio(i){
        this.list_radio=i;
      },
      //点击关闭图标
      close(){
        this.$emit('close_project')
      },
      //点击取消
      cancel_selection(){
        this.list_radio='';
      },
      //点击确定
      determine(){
        var data='';
        this.list_data.forEach((item)=>{
          if(item.fld_record_id==this.list_radio){
            if(item.fld_name){
              data=item.fld_name
            }
          }
        })
        this.$emit('input_data',data) 
        },
    },
    directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('modal-header')[0];
          dragBox.onmousedown = e => {
              //算出鼠标相对元素的位置
              let disX = e.clientX - drag_Box.offsetLeft;
              let disY = e.clientY - drag_Box.offsetTop;
              document.onmousemove = e => {
                console.log(1)
                  //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  let left = e.clientX - disX;
                  let top = e.clientY - disY;
                  //移动当前元素
                  drag_Box.style.left = left + "px";
                  drag_Box.style.top = top + "px";
              };
              document.onmouseup = e => {
                    //鼠标弹起来的时候不再移动
                    document.onmousemove = null;
                   //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
                  document.onmouseup = null;
              };
          };
        }
      }
    }
  }
</script>
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .th{
    background: white;
  }
  .fa-spin{
	    -webkit-animation: fa-spin 1s infinite linear;
      animation: fa-spin 1s infinite linear;
	}
  .modal-footer{
    justify-content: space-between;
  }
	.loading{
		z-index: 1000;
		font-size: 50px;
		position: absolute;
		color: rgb(138, 132, 132);
		top: 50%;
		left: 50%;
		/* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
		text-align: center;
	}
  .modal-header{
    cursor: move;
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
    padding-top: 0;
  }
  .table>tbody>tr>td {
    text-align: center;
  }
  .table>thead>tr>th {
    text-align: center;
  }
	.project{
    min-width: 846px;
    position: fixed;
    top: 50%;
    left: 50%;
    height: 500px;
    z-index:999;
    transform: translate(-50%, -50%);
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  /* transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px)); */
  }
 .modal-header{
		background:#ebecf0;
		height:40px
	}
 .modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
  .btn-default-close{
    color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 90%; */
  }
  .btn-default-determine{
    color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
  }
  td{
    font-size: 12px;
  }
</style>